import React, { Fragment } from 'react'

export default function SkeletonHeader() {
  return (
    <Fragment>
      <section>
        <div className="cic-rate-state-wrapper">
          <div className="rate-state-background rect-gray ">
            
          </div>
          <div className="rate-state-info">
              <div className="rate-state-title">
                <div className=''>
                  <h1 itemProp="name"><span className='rect-gray loading-info'>California Check Cashing Stores Location, CA</span></h1>
                </div>
              </div>
              <div className="rate-state-table ">
                  <h2 className="txtLeft h2-sub "><span className='rect-gray loading-info'>Location, CA</span></h2>
                  <div className="rt-loan-amount" itemProp="address" itemType="https://schema.org/PostalAddress">
                      <div className="iconDiv topTel">
                          <div className="cic-gray-filter spaceIcon mm-icon-wrapper noRepeat IconPhone"></div>
                          <div>
                              <a title="Information is loading" aria-label="Information is loading">
                              <h3 className="h3-third"><span className='rect-gray loading-info'>Information is loading </span></h3>
                              </a>
                          </div>
                      </div>
                  </div>
                  <div className="rt-loan-amount" itemProp="address" itemType="https://schema.org/PostalAddress">
                      <div className="iconDiv">
                          <div className="cic-gray-filter spaceIcon mm-icon-wrapper noRepeat IconMapPin"></div>
                          <div>
                              <a title="Click here to get the Google Map directions" aria-label="Click here to get the Google Map directions">
                                  <h3 className="h3-third"><span className='rect-gray loading-info'>Information is loading </span></h3>
                              </a>
                          </div>
                      </div>
                  </div>
                  <div className="rt-loan-amount">
                      <div className="iconDiv">
                          <div className="spaceIcon mm-icon-wrapper IconClock noRepeat cic-gray-filter"></div>
                          <div>
                              <a title="Click here to get the Google Map directions" aria-label="Click here to get the Google Map directions">
                                  <h3 className="h3-third"><span className='rect-gray loading-info'>Information is loading </span></h3>
                              </a>
                          </div>
                      </div>
                  </div>
              </div>
              <div className="rate-state-buttons gap-buttons " itemProp="hasMap" itemType="https://schema.org/Map">
                  <button 
                    disabled 
                    className="cic-btn cic-btn-get-started my-3" 
                    aria-label="Click here to apply for a California Check Cashing Stores Payday Loan now"
                  >
                    Get Started Online
                  </button>
                  <button
                      itemProp="mapType"
                      rel="noopener noreferrer"
                      target="_blank"
                      disabled
                      className="cic-btn cic-btn-secondary--dark my-3 "
                      aria-label="Click here to get the directions from this store"
                  >
                      Get Directions
                  </button>
              </div>
              <div className="rate-state-callus ">
                  <p className="cic-paragraph--medium ml-2"><a title="Back to Stores List" rel="noopener noreferrer" aria-label="Back to Stores List" ><span className='rect-gray loading-info'>Back to Stores List</span></a></p>
              </div>
          </div>
        </div>

      </section>
    </Fragment>
  )
}
